
import { Component, Mixins } from 'vue-property-decorator';
import SocialLinks from '@/features/auth/components/signIn/SocialLinks.vue';
import ResponsivenessMixin from '@/features/common/mixins/responsivenessMixin';

@Component({
  components: {
    SocialLinks,
  },
})
export default class LogoutCard extends Mixins(ResponsivenessMixin) {
  private legacyLogoutPageUrl = `${window.location.origin}/webship/logout.aspx`;

  get redirectUrlQuery(): string {
    return this.$route.query.redirectUrl as string;
  }

  private created(): void {
    if (this.redirectUrlQuery) {
      this.$router.push(this.redirectUrlQuery);
    }
  }
}
